/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_NewInputs */



/**
* | output |
* | --- |
* | "What's New" |
*
* @param {Whats_NewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const whats_new = /** @type {((inputs?: Whats_NewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_NewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveautés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Was ist neu")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cosa c'è di nuovo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Что нового")
	if (locale === "es") return /** @type {LocalizedString} */ ("Qué hay de nuevo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("什么是新的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新着情報")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया क्या है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O que há de novo")
	return /** @type {LocalizedString} */ ("What's New")
});